// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aroma-profile[data-v-187a94c7]{position:relative;background-color:#f9f9f9;width:100%;min-height:100%;display:flex;flex-direction:column;align-items:center;padding-top:2.13333vw}.aroma-profile__button[data-v-187a94c7]{width:91.46667vw;margin-top:9.33333vw}", ""]);
// Exports
module.exports = exports;
